import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names safely.
 *
 * Combines clsx's conditional/array-friendly syntax with tailwind-merge's
 * later-wins behaviour for conflicting Tailwind utilities (e.g. passing
 * `'p-2'` then `'p-4'` resolves to `'p-4'`).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
